import { html } from "lit-element";
import { DrawingModuleContainer } from "../../ModuleBase/DrawingModuleContainer";
import { PolygonModule } from "./polygon-module.js";
import { filled, outline, cancelIcon, okIcon, } from "./drawing-polygon.js";

export class PolygonModuleContainer extends DrawingModuleContainer {
	constructor(canvas, getColor, drawingHistory) {
		super(canvas);

		this.moduleId = "polygon";
		this.toolbarWidth = "40px";
		this.icon = filled;
		this.label = "Polygon";

		this.submodules.push(new PolygonModule(this, canvas, getColor, filled, drawingHistory, "filled"));
		this.submodules.push(new PolygonModule(this, canvas, getColor, outline, drawingHistory, "outline"));
	}
    
	editPolygon(polygon) {
		const tool = document.querySelector('inspx-drawing-tool');
		tool.activateModule(this);
		if (this.activeSubmodule) {
			this.activeSubmodule.edit(polygon);
		}
	}

	render() {
		return html` 
	        ${super.render()}
	        <style> 
				.controls {
					margin-top: 10px;
				}
				
				.controls .btn {
					height: 30px;
					margin-top: 10px;
				}

				.controls svg { 
					stroke: none; 
					cursor: pointer; 
					height: 30px;
					width: 30px;
					padding: 0 5px;
				}
			</style>
	        <div class="shapes controls">
				<div class="btn" title="Cancel" @click="${() => this.cancelClickHandler()}">${cancelIcon}</div>
				<div class="btn" title="Save" @click="${() => this.okClickHandler()}">${okIcon}</div>
	        </div>`;
	}

	okClickHandler() {
		if (this.activeSubmodule) {
			this.activeSubmodule.save();
		}
	}

	cancelClickHandler() {
		if (this.activeSubmodule) {
			this.activeSubmodule.cancel();
		}
	}
}

window.customElements.define("inspx-draw-polygon-container", PolygonModuleContainer);
